import { useState, useCallback } from "react";

export default function useCookie(name, defaultValue) {
  const [value, setValue] = useState(() => {
    // Get cookie by name
    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`))
      ?.split("=")[1];

    if (cookieValue) return cookieValue;

    // Set default value if no cookie exists
    document.cookie = `${name}=${defaultValue};path=/;max-age=31536000000`;
    return defaultValue;
  });

  const updateCookie = useCallback(
    (newValue) => {
      // Simple set with path=/ for site-wide access
      document.cookie = `${name}=${newValue};path=/;max-age=31536000000`;
      setValue(newValue);
    },
    [name]
  );

  const deleteCookie = useCallback(() => {
    // Delete by setting expired date
    document.cookie = `${name}=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    setValue(null);
  }, [name]);

  return [value, updateCookie, deleteCookie];
}
